import c0 from './modal_controller';
import c1 from './refresh_controller';
import c2 from './password_visibility_controller';
import c3 from './password_check_controller';
import c4 from './autosubmit_controller';
import c5 from './popup_controller';
import c6 from './screenshot_controller';
import c7 from './clipboard_controller';
import c8 from './forms/dependend_field_visibility_controller';
import c9 from './query_controller';
import c10 from './select_controller';
import c11 from './richtext_controller';
import c12 from './scroll_to_controller';
import c13 from './image_upload_controller';
import c14 from './sortable_controller';
import c15 from './autocomplete_controller';
import c16 from './tooltip_controller';
import c17 from './rich_text_area_controller';
import c18 from './sync_width_controller';
import c19 from './range_controller';
import c20 from './nested_form_controller';
export const definitions = [
	{identifier: 'modal', controllerConstructor: c0},
	{identifier: 'refresh', controllerConstructor: c1},
	{identifier: 'password-visibility', controllerConstructor: c2},
	{identifier: 'password-check', controllerConstructor: c3},
	{identifier: 'autosubmit', controllerConstructor: c4},
	{identifier: 'popup', controllerConstructor: c5},
	{identifier: 'screenshot', controllerConstructor: c6},
	{identifier: 'clipboard', controllerConstructor: c7},
	{identifier: 'forms--dependend-field-visibility', controllerConstructor: c8},
	{identifier: 'query', controllerConstructor: c9},
	{identifier: 'select', controllerConstructor: c10},
	{identifier: 'richtext', controllerConstructor: c11},
	{identifier: 'scroll-to', controllerConstructor: c12},
	{identifier: 'image-upload', controllerConstructor: c13},
	{identifier: 'sortable', controllerConstructor: c14},
	{identifier: 'autocomplete', controllerConstructor: c15},
	{identifier: 'tooltip', controllerConstructor: c16},
	{identifier: 'rich-text-area', controllerConstructor: c17},
	{identifier: 'sync-width', controllerConstructor: c18},
	{identifier: 'range', controllerConstructor: c19},
	{identifier: 'nested-form', controllerConstructor: c20},
];
